import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Icon, Pagination } from "semantic-ui-react";
import {
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableCell,
  TableBody,
  Table,
} from "@material-ui/core";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  StyledLabel,
  SemanticButton,
  ContainerPaginate,
  ButtonIcon,
  ActionBtnWrapper,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import Back from "../../../components/Admin/Cupons/Back";
import { cupomSchema } from "../../../components/Admin/Cupons/Validation/CupomValidation";
// import { canEditOrDelete, godPrivUsers,parceriaUsers } from "../../../utils/Utils";
import { getUSER } from "../../../services/auth";

const Cupons = props => {
  const user = getUSER(); //obter usuário atual
  const [cupons, setCupons] = useState([]);
  const [search, setSearch] = useState("");
  const [dataInicial, setDataInicial] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [pages, setPages] = useState(0);

  useEffect(() => {
    if (dataFinal || dataInicial) {
      loadSearchData();
      return;
    }
    loadCupons();
  }, [currentPage, search]);

  const loadCupons = useCallback(async () => {
    try {
      const params = {
        page: currentPage,
      };

      if (search) {
        params.search = search;
      }

      const response = await api.get("admin/cupons", { params });
      const { cupons, count } = response.data;
      let array = { local: "cupom", texto: `listou os cupons` };
      await api.post("system_logs", { acao: JSON.stringify(array) });

      setCupons(cupons);
      setPages(Math.ceil(count / 50));
    } catch (err) {
      console.error(err);
      swal("Não foi possível carregar os cupons", "", "").then(res =>
        props.history.push("/")
      );
    }
  }, [currentPage, search]);

  const loadSearchData = useCallback(async () => {
    try {
      const params = {
        page: currentPage,
      };

      if (search) {
        params.search = search;
      }
      const response = await api.get(
        `admin/cupons/search/${dataInicial}/${dataFinal}`,
        { params }
      );
      const { cupons, count } = response.data;

      setCupons(cupons);
      setPages(Math.ceil(count / 50));
    } catch (err) {
      console.error(err);
      swal("Não foi possível carregar todos os cupons", "", "").then(res =>
        props.history.push("/")
      );
    }
  }, [search, dataInicial, dataFinal, currentPage]);

  const cleanAll = useCallback(() => {
    setSearch("");
    setDataInicial(Date);
    setDataFinal(Date);
    loadCupons();
  });

  const removeCupom = useCallback(
    id => {
      swal("Remoção de Cupom", "Você tem certeza que quer remover? ", "").then(
        res => {
          if (res) {
            api.delete(`admin/cupons/${id}`).then(res => {
              let array = {
                local: "cupom",
                texto: `deletou o cupom de id=${id}`,
              };
              api.post("system_logs", { acao: JSON.stringify(array) });
              const newCupons = [...cupons].filter(cup => cup.id !== id);
              setCupons(newCupons);
            });
          }
        }
      );
    },
    [cupons]
  );

  const copyCupom = useCallback(
    async data => {
      swal({
        text: "Digite o nome do novo cupom",
        content: "input",
        button: {
          text: "Criar!",
          closeModal: true,
        },
      })
        .then(async voucher => {
          const payload = {
            ...data,
            codigo: voucher.toString().toUpperCase(),
            id: null,
          };

          const isValid = await cupomSchema.isValid(payload);

          if (!isValid) {
            swal("Favor preencha todos os campos obrigatórios ", "", "warning");
            return;
          }

          await api
            .post("admin/cupons", payload)
            .then(res => {
              setCupons([res.data.cupom, ...cupons]);
              swal("Cupom criado ", "", "success");
            })
            .catch(err => {
              swal("Erro:", err, "error");
            });
        })
        .catch(err => {
          swal("Erro ao fazer a solicitação", err, "error");
        });
    },
    [cupons]
  );

  const copyToClipboard = useCallback(coupon => {
    navigator.clipboard.writeText(coupon);
    swal(`Cupom ${coupon} copiado`, "", "success");
  });

  // const canEditOrDelete = (email) => {
  //   // verificar se o usuário atual está na lista de usuários permitidos
  //   const isGodPrivUser = godPrivUsers.some((godPrivUser) => godPrivUser === user.email);
  //   const isParceriaUser = parceriaUsers.some((parceriaUser) => parceriaUser === user.email);

  //   return  isGodPrivUser || isParceriaUser;
  // };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Back />
          <Title>Cupons</Title>

          <ContainerInputSearch className="ui fluid left icon input">
            <Input
              type="search"
              placeholder="Procurar cupons"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <Icon name="search icon" />
            <CreateButton to="/admin/cupons/criar">Criar</CreateButton>
          </ContainerInputSearch>

          <ContainerInputSearch>
            <Input
              type="date"
              value={dataInicial}
              onChange={e => setDataInicial(e.target.value)}
            />
            <StyledLabel>Até</StyledLabel>
            <Input
              type="date"
              value={dataFinal}
              onChange={e => setDataFinal(e.target.value)}
            />
            <SemanticButton onClick={loadSearchData}>
              Buscar por data
            </SemanticButton>
            <SemanticButton onClick={cleanAll}>Limpar</SemanticButton>
          </ContainerInputSearch>

          <TableContainer>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow
                  style={{
                    textAlign: "center",
                    backgroundColor: "#e0e1e2",
                  }}
                >
                  <TableCell style={{ fontWeight: "700" }} align="left">
                    Código do Cupom
                  </TableCell>
                  <TableCell style={{ fontWeight: "700" }} align="left">
                    Desconto
                  </TableCell>
                  <TableCell style={{ fontWeight: "700" }} align="left">
                    Descrição
                  </TableCell>
                  <TableCell style={{ fontWeight: "700" }} align="left">
                    Treinamentos
                  </TableCell>
                  <TableCell style={{ fontWeight: "700" }} align="center">
                    Ativo
                  </TableCell>
                  <TableCell style={{ fontWeight: "700" }} align="center">
                    Id Pessoa
                  </TableCell>
                  <TableCell style={{ fontWeight: "700" }} align="left">
                    Data
                  </TableCell>
                  <TableCell style={{ fontWeight: "700" }} align="center">
                    Validade
                  </TableCell>
                  <TableCell style={{ fontWeight: "700" }} align="center">
                    Validade Curso
                  </TableCell>
                  <TableCell style={{ fontWeight: "700" }} align="center">
                    Ações
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {cupons.map((coupon, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell
                      scope="coupon"
                      title="Copiar código"
                      onClick={() => copyToClipboard(coupon.codigo)}
                      style={{ cursor: "pointer" }}
                    >
                      {coupon.codigo}
                    </TableCell>
                    <TableCell>
                      {coupon.desconto} ({coupon.ispercent === 1 ? "%" : "R$"})
                    </TableCell>
                    <TableCell align="left">{coupon.descricao}</TableCell>
                    <TableCell
                      align="left"
                      style={{ maxWidth: "50px" }}
                      title={coupon.treinamentos}
                    >
                      {coupon.treinamentos.length > 10
                        ? `${coupon.treinamentos.slice(0, 10)}...`
                        : coupon.treinamentos.length > 0
                        ? coupon.treinamentos
                        : "N/A"}
                    </TableCell>
                    <TableCell align="center">{coupon.num_usos}</TableCell>
                    <TableCell align="center">{coupon.id_pessoa}</TableCell>
                    <TableCell align="left">
                      {coupon.data_sys.toString().substring(0, 10)}
                    </TableCell>
                    <TableCell align="left">
                      {coupon.validade
                        ? coupon.validade.toString().substring(0, 10)
                        : "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      {" "}
                      {coupon.validade_curso !== 0
                        ? coupon.validade_curso.toString().substring(0, 10)
                        : "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      <ActionBtnWrapper>
                        <ButtonIcon onClick={() => copyCupom(coupon)}>
                          <Icon
                            title="Duplicar cupom"
                            name="copy"
                            color={"blue"}
                          />
                        </ButtonIcon>
                        <ButtonIcon
                          onClick={() =>
                            window.open(`/admin/cupons/${coupon.id}`)
                          }
                        >
                          <Icon
                            title="Editar cupom"
                            name="edit"
                            color={"blue"}
                          />
                        </ButtonIcon>

                        <ButtonIcon onClick={() => removeCupom(coupon.id)}>
                          <Icon
                            title="Excluir cupom"
                            name="trash"
                            color={"red"}
                          />
                        </ButtonIcon>
                      </ActionBtnWrapper>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <ContainerPaginate>
            <Pagination
              defaultActivePage={1}
              ellipsisItem={null}
              // siblingRange={1}
              totalPages={pages}
              onPageChange={(e, f) => setCurrentPage(f.activePage)}
              page={currentPage}
            />
          </ContainerPaginate>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(Cupons);
